import { useKycVerificationContext } from "../../Contexts/KycVerificationContext";
import { MenuItem, Select } from "@mui/material";
import React from "react";

function IdType() {
  const { formData, setFormData, errorMessage, setErrorMessage } =
    useKycVerificationContext();

  const ids = [
    { name: "Passport", id: "9" },
    { name: "Driving License", id: "240" },
    {name: "Postal Premium ID", id: "241"},
    {name: "Postal Basic ID", id: "242"},
    { name: "UMID", id: "243" },
    { name: "National ID", id: "244" },
    { name: "Non-professional Driving License", id: "246" },
    { name: "Professional Driving License", id: "247" },
    { name: "Professional ID", id: "248" },
    { name: "SSS", id: "249" },
  ];

  const handleChange = (e) => {
    const selectedId = e.target.value;
		const selectedObject = ids.find(
			(data) => data.id === selectedId
		);
    let newForm = {
      ...formData,
      selectedID: selectedObject,
    };
    setFormData(newForm);
    setErrorMessage("");
  };

  let errMsg = errorMessage && (
    <p className="font-bold text-red-600 mb-2">{errorMessage}</p>
  );

  return (
    <div className="p-4">
      <p className="text-[#1F2328] text-xl font-bold mb-1">
        Type of ID to be submitted
      </p>
      <p className="text-[#60656D] mb-4">
        Please choose which identification document you would prefer to capture
        for verification
      </p>
      {errMsg}
      <Select
        placeholder="Select ID"
        className="w-full h-10"
        value={formData.selectedID?.id}
        onChange={handleChange}
      >
        {ids.map((item) => (
          <MenuItem key={item} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

export default IdType;
